import React, { Component } from 'react';

import { Row, Col, Button } from 'react-bootstrap';

import * as constants from '../../config/constants/AppConstants';

const UI_SIZE = constants.AppSettings.UI_SIZE;

class CommonToolbar extends Component {

    state = {
        isRefresh: false
    }

    handleRotateClick = () => {
        this.setState({ isRefresh: true });

        setTimeout(() => {
            this.setState({ isRefresh: false });
        }, 500);
    };

    render = () => {

        let { config, empty, userPermit , Operation, Deletes, onToggleSearch, onRefreshDataTable, onCreateItem, onModalAction } = this.props; // permitPrint, onPrintItem, 

        // if(!config?.display) return null;

        return (
                <Row className="justify-content-end">
                    <Col md="auto">
                        <div className="hk-toolbar toolbar-asymmetric mb-3">
                            
                        {config?.display && (
                            <ul className="nav nav-light px-1 align-items-center">

                                <li className="nav-item nav-link px-1">
                                    <Button 
                                            className={`btn-${UI_SIZE} btn-icon btn-rounded flush-soft-hover  ${Operation?.Search ? " btn-flush-primary" : "btn-flush-dark "}`}
                                            onClick={(e) => onToggleSearch(e)}
                                    >
                                        <span className="icon">
                                            <i className="fa-classic fa-light fa-magnifying-glass fa-fw" />
                                        </span>
                                    </Button>
                                </li>

                                <li className="nav-item nav-link px-1">
                                    <Button 
                                        className={`btn-${UI_SIZE} btn-icon btn-flush-dark btn-rounded flush-soft-hover`}
                                        onClick={async (e) => {
                                            this.handleRotateClick(e);
                                            await onRefreshDataTable(e);
                                        }}
                                    >
                                        <span className="icon">
                                            <i className={`fa-classic fa-light fa-arrows-rotate fa-fw ${this.state.isRefresh ? 'icon-rotate-animation' : ''}`} />
                                        </span>
                                    </Button>
                                </li>

                                {config.toolbars?.delete && Deletes?.deletes?.length > 0 && (
                                    <>
                                        <li className="nav-item nav-link px-1">
                                            <div className="vr mx-1" style={{ borderLeft: '1px solid rgb(90, 90, 90)', height: '24px' }}></div>
                                        </li>

                                        <li className="nav-item nav-link px-1">
                                            <Button 
                                                variant="outline-danger" 
                                                className={`btn-${UI_SIZE} btn-icon btn-rounded flush-soft-hover`}
                                                onClick={(e) => onModalAction({mode: 'confirm-delete', show: true, action: false})}
                                            >
                                                <i className="fa-classic fa-light fa-trash-xmark fa-fw" />
                                            </Button>
                                        </li>
                                    </>
                                )}

                                {/* {config.toolbars?.new && !empty && (userPermit !== true) && (permitPrint !== false) (
                                    <>
                                        <li className="nav-item nav-link px-1">
                                            <div className="vr mx-1" style={{ borderLeft: '1px solid rgb(90, 90, 90)', height: '24px' }}></div>
                                        </li>
                                        <li className="nav-item nav-link px-1">
                                            <Button 
                                                variant="success" 
                                                className={`btn-${UI_SIZE} btn-rounded flush-soft-hover d-inline-flex align-items-center`}
                                                // onClick={(e) => onPrintItem(e)}
                                                >
                                                <i className="fa-classic fa-light fa-circle-plus fa-fw me-2" />
                                                Export Excel
                                            </Button>
                                        </li>                                    
                                    </>
                                )} */}

                                {config.toolbars?.new && !empty && (userPermit !== false) && (
                                    <>
                                        <li className="nav-item nav-link px-1">
                                            <div className="vr mx-1" style={{ borderLeft: '1px solid rgb(90, 90, 90)', height: '24px' }}></div>
                                        </li>
                                        <li className="nav-item nav-link px-1">
                                            <Button 
                                                variant="primary" 
                                                className={`btn-${UI_SIZE} btn-rounded flush-soft-hover d-inline-flex align-items-center`}
                                                onClick={(e) => onCreateItem(e)}
                                                >
                                                <i className="fa-classic fa-light fa-circle-plus fa-fw me-2" />
                                                สร้างรายการ
                                            </Button>
                                        </li>                                    
                                    </>
                                )}

                            </ul>
                        )}
                        </div>
                    </Col>
                </Row>
        );
    }
}

export default CommonToolbar;
